// extracted by mini-css-extract-plugin
export default {"container":"sign-up_container__O39+Z"};